import { render, staticRenderFns } from "./PagamentoDesassociarEtapa.vue?vue&type=template&id=021e4fe1"
import script from "./PagamentoDesassociarEtapa.vue?vue&type=script&lang=js"
export * from "./PagamentoDesassociarEtapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports